module.exports = __webpack_public_path__ + "img/pic_bank_CMB@2x.9ba386fd.png";